import React,{useState} from 'react';

import axios from 'axios';

import swal from 'sweetalert';

const AddCategory = () => {

    const [formData, setFormData] = useState({
        slug: '',
        name: '',
        description: '',
        meta_title: '',
        meta_keyword: '',
        meta_description: '',
        status: false,
        error_list: [],
    });

    const resetFormData = () => {
        setFormData({
            slug: '',
            name: '',
            description: '',
            meta_title: '',
            meta_keyword: '',
            meta_description: '',
            status: false,
            error_list: [],
        });
    }

    const handeInput = (e) => {
        e.persist();
        const {name, value, type, checked} = e.target;
        setFormData({ ...formData, [name]: type==="checkbox" ? checked : value });
    }

    const handleFormSubmit = (e) => {
        e.preventDefault();
     
        let data = JSON.stringify({
            slug: formData.slug,
            name: formData.name,
            description: formData.description,
            meta_title: formData.meta_title,
            meta_keyword: formData.meta_keyword,
            meta_description: formData.meta_description,
            status: formData.status,
        });
        
        axios.post(`api/store-category`, data)
            .then(res => {
                if (res.data.status === 200) {
                    swal("Success", res.data.message, "success");
                    resetFormData(); 
                } else if (res.data.status === 400) {
                    setFormData({ ...formData, error_list: res.data.validation_errors });
                }
            });
    }

    let displayErrors = [];
    if (formData.error_list) {
        displayErrors = [
            formData.error_list.slug,
            formData.error_list.name,
            formData.error_list.meta_title,
        ];
    }

    return (
        <form onSubmit={handleFormSubmit} id="CATEGORY-FORM">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h3 className="h5 mb-0 text-gray-800">Add Category</h3>
                </div>
                {
                    displayErrors.map((item, idx) => {
                        return (<p className="pl-2 mb-1" key={idx}>{item}</p>)
                    })
                }
                <div className="card-body">
                    <ul className="nav nav-pills">
                        <li className="nav-item">
                            <a className="nav-link active" data-bs-toggle="pill" href="#main-details">
                                Main Details
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="pill" href="#seo-details">
                                SEO Details
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content">
                        <div className="tab-pane container active" id="main-details">
                            <div className="mb-3 mt-3">
                                <label className="form-label">slug</label>
                                <input type="text" className="form-control" name="slug" onChange={handeInput} value={formData.slug} />
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Name</label>
                                <input type="text" className="form-control" name="name" onChange={handeInput} value={formData.name} />
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Description</label>
                                <textarea className="form-control" name="description" onChange={handeInput} value={formData.description}></textarea>
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label pr-2">Status</label>
                                <input type="checkbox" name="status" onChange={handeInput} value={formData.status} checked={formData.status} />
                                <span className='pl-3'> Status 0 = shown, 1 = hidden</span>
                            </div>
                        </div>
                        <div className="tab-pane container fade" id="seo-details">
                            <div className="mb-3 mt-3">
                                <label className="form-label">Title</label>
                                <input type="text" className="form-control" name="meta_title" onChange={handeInput} value={formData.meta_title} />
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Keywords</label>
                                <input type="text" className="form-control" name="meta_keyword" onChange={handeInput} value={formData.meta_keyword} />
                            </div>
                            <div className="mb-3 mt-3">
                                <label className="form-label">Description</label>
                                <textarea className="form-control" name="meta_description" onChange={handeInput} value={formData.meta_description}></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="submit" className="btn btn-primary mb-2 mr-3 ml-3">Submit</button>

            </div>
        </form>
    );
}

export default AddCategory;